import productData from "../assets/json/atmosproducts.json";

export const { productSeries } = productData;

export const getProductSeries = () => {
  return productSeries;
};

export const getModelsBySeries = (seriesName) => {
  const series = productSeries.find((series) => series.name === seriesName);
  return series ? series.models : [];
};
